import { ca } from '@cian/analytics';

interface ITrackNavigationToCardJK {
  id: number;
}

export function trackNavigationToCardJK({ id }: ITrackNavigationToCardJK) {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'Compare',
    action: 'to_cardjk',
    products: [{ id }],
  });
}
